/**
 * This file includes new color scales from the .PalettePrimitives Figma collection
 * which will be adopted in a future migration.
 */

export const white = '#FFFFFF';
export const black = '#000000';

export const alpine = {
    50: '#F2F7F9',
    100: '#E5F0F4',
    200: '#D3E6EC',
    300: '#B9D6E1',
    400: '#7DB3C7',
    500: '#3B8DAB',
    600: '#17789B',
    700: '#115670',
    800: '#0A3544',
    900: '#051A22'
} as const;

export const blue = {
    50: '#F3F7FD',
    100: '#E7EEFC',
    200: '#D8E3F9',
    300: '#C0D2F6',
    400: '#8AABEE',
    500: '#4F81E5',
    600: '#2E69E0',
    700: '#214CA1',
    800: '#142E62',
    900: '#0A1731'
} as const;

export const cyan = {
    50: '#F2F8F8',
    100: '#E4F0F0',
    200: '#D2E6E6',
    300: '#B8D8D8',
    400: '#7AB6B6',
    500: '#369191',
    600: '#117C7C',
    700: '#0C5959',
    800: '#073636',
    900: '#041B1B'
} as const;

export const green = {
    50: '#F1F8F5',
    100: '#E4F1EC',
    200: '#D2E7DF',
    300: '#B7D9CC',
    400: '#78B8A0',
    500: '#34946F',
    600: '#0F7F55',
    700: '#0B5C3D',
    800: '#073825',
    900: '#031C12'
} as const;

export const grey = {
    50: '#F6F6F7',
    100: '#EDEEF0',
    200: '#E1E2E6',
    300: '#D0D1D7',
    400: '#A8ABB5',
    500: '#808391',
    600: '#6C6F7B',
    700: '#4E5058',
    800: '#2F3035',
    900: '#17171A'
} as const;

export const khaki = {
    50: '#F5F7F3',
    100: '#EBEFE7',
    200: '#DDE5D7',
    300: '#C9D6BF',
    400: '#9BB289',
    500: '#6D8D53',
    600: '#5C7746',
    700: '#425633',
    800: '#28341F',
    900: '#14190F'
} as const;

export const orange = {
    50: '#FEF5ED',
    100: '#FDEBDA',
    200: '#FCDDC1',
    300: '#FBC89C',
    400: '#F89242',
    500: '#C76C29',
    600: '#A95B24',
    700: '#7B411A',
    800: '#4B2710',
    900: '#241409'
} as const;

export const pink = {
    50: '#FFF4F8',
    100: '#FFE8F1',
    200: '#FFD8E8',
    300: '#FFC0DA',
    400: '#FF83B5',
    500: '#E24B88',
    600: '#BF4074',
    700: '#8A2E53',
    800: '#551C33',
    900: '#2A0E1A'
} as const;

export const purple = {
    50: '#F7F5FE',
    100: '#F0EBFC',
    200: '#E6DFFB',
    300: '#D7CBF8',
    400: '#B49FF2',
    500: '#8E6EEB',
    600: '#7953E8',
    700: '#552BCC',
    800: '#341B7E',
    900: '#1A0D3F'
} as const;

export const red = {
    50: '#FEF4F4',
    100: '#FDE9E8',
    200: '#FCDBD9',
    300: '#FAC5C1',
    400: '#F68E87',
    500: '#F04438',
    600: '#CC3A30',
    700: '#942A22',
    800: '#5B1A15',
    900: '#2E0D0B'
} as const;

export const yellow = {
    50: '#FBF7E1',
    100: '#F9EEC3',
    200: '#F8E199',
    300: '#F6CD5A',
    400: '#CEA643',
    500: '#A27F34',
    600: '#8B6A2C',
    700: '#664B20',
    800: '#3F2D14',
    900: '#1E1609'
} as const;
